module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lake Garda, Italy "), _c('br'), _vm._v("June 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("‘I’"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LL")]), _vm._v(" be home in a couple of days, darling.’ Annie spoke warmly into her mobile, totally unaware of the sunshine and beauty of the scenery of the lake outside the long windows of the bustling hotel as she hurried down the carpeted hallway to the conference room on the ground-floor level. ‘I love you too, Oliver—oomph!’ Annie was brought to an abrupt—and painful—halt as she crashed into an immovable object.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A warm, firmly muscled, very male object, Annie recognised as the free hand she had raised to steady herself came to rest on one broad shoulder and she felt the ripple of those powerful muscles beneath her fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m so sorry—’ Annie’s laughing apology strangled in her throat, her face paling, as she looked up into the coldly brooding, breathlessly handsome face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It couldn’t be Luc!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Could it?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Annie felt absolutely stunned. Could this man really be the same one she’d met four and a half years ago? ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Apart from the fact that she had only ever seen the tall and lithely muscled Luc in ski wear or casual denims and cashmere sweaters, and this man was dressed in an expensively tailored suit and white silk shirt with a silver-coloured tie meticulously knotted at his throat, he certainly looked a lot like the man Annie had met, and spent a hot and steamy night with, all those years ago. Except…")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That Luc had had shoulder-length dark hair, whereas this man’s hair was cut short—in an effort to control the inclination it’d had to curl? But this man’s eyes, dark as onyx in an arrogant and harshly uncompromising face, were the same. As was the long slash of a nose, and the chiselled mouth above a ruthlessly set jaw.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked identical, and yet, at the same time, so very different…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Luc Annie had met on an Italian ski slope four and a half years ago had possessed a reckless glint in the ebony darkness of his eyes. His hard grin had betrayed that same air of devil-may-care that had drawn the quiet and—until then—eminently sensible twenty-year-old Annie to him, like a moth to a flame.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was not even a hint of that dangerous recklessness now in those penetrating black eyes that returned Annie’s gaze so coldly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eyes that also seemed to totally lack the same jolting recognition that she now felt…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Annie removed her hand as if burnt from the broadness of his shoulder as she took an involuntary step backwards. At the same time becoming aware that she hadn’t so much as drawn in a breath since she had looked up and instantly recognised her fiercely passionate lover in this icily controlled man.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Annie took a much-needed breath. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Scuse, signore—’")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I speak English, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("signorina")]), _vm._v(",’ he bit out curtly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dear God, that voice…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No amount of steely coldness could ever disguise the voice that had once murmured husky encouragements against Annie’s throat and breasts as she climaxed again and again beneath the fierce, possessive thrusts of his hard body… It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" Luc.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But a different, much colder Luc than Annie remembered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Twenty-six-year-old Luc had been wild and restless. Everything he did—from skiing to lovemaking—had been possessed of a driving, single-minded energy that dared anything and anyone to deny him. The same single-minded energy with which he had set out—and succeeded—in seducing Annie…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No one looking at the man standing in front of her could ever doubt that he possessed that same determination of purpose. But now that energy was as fiercely controlled as it had once been wild, and his emotions were hidden behind a face that showed only an arrogance and ruthlessness that made Annie shiver as he continued to look down at her coldly from a vastly superior height.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Luc’s patience, never at a premium, evaporated with each second that this young woman continued to stare up at him as if she had seen a ghost. Or her worst nightmare. Certainly not the reaction that Luc was accustomed to evoking in any woman!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A humourless smile curled his lips. ‘Or perhaps it is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("signora")]), _vm._v("?’ he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, you were right the first time,’ she answered.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luc felt a slight stirring of memory as the woman spoke softly. Her voice possessed a husky quality that somehow seemed familiar.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He took in her medium height and slender body, clothed in a black business suit and white silk blouse. Her hair was a deep chestnut brown secured at her nape, her face heart shaped. It was an arrestingly beautiful face with a small, uptilted nose, and sensually full lips above a pointed and determined chin. A face dominated by eyes as deep a blue as Lake Garda itself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Again Luc felt that slight stirring of familiarity. ‘Have we met before, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("signorina")]), _vm._v("?’ he asked slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She blinked before giving a brittle, dismissive laugh. ‘I don’t know, have we?’ she said, deflecting his question back at him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luc bit back his increasing impatience. ‘I believe "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I")]), _vm._v(" asked first?’ he pointed out coldly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And he could go on asking, as far as Annie was concerned! All this time, all these years, Annie’s worst fear had been that she would somehow, somewhere, meet Luc again. A meeting that she knew would complicate her life in ways she didn’t even want to contemplate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now, by some terrible mischance, she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" met him again, had met the man who had changed her own life forever—and he didn’t even "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("remember")]), _vm._v(" her!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The relief Annie should have felt was overlaid by a deep resentment. This man had literally skied his way into her life and introduced the normally reserved Annie Balfour to an intensity of passion and excitement she had never known before or since, before disappearing again just as abruptly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Only for her to now realise that their time together, all those wonderful memories that she had never quite ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("been able to put from her mind, had meant so little to him that he didn’t even remember her. Arrogant louse!")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her chin lifted in silent challenge. ‘I’m sure "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("one")]), _vm._v(" of us would have remembered if that were the case, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("signore")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luc wasn’t so sure. The pallor of this woman’s face, the angry resentment he sensed beneath her tone, seemed to tell a completely different story. One in which he had patently not appeared in a good light.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As the only son and heir of a rich and powerful Italian business entrepreneur, Luc’s youth had been one of wealth and privilege, with his every wish being granted. As a consequence, Luc knew he had become arrogant, and possessed of an overconfidence in his own infallibility. A youthfully arrogant belief that had continued after he had proved to have his father’s flare for business, and at only eighteen had been placed in a position of power within his father’s business empire. Until the overconfident Luc had taken one risk too many and the whole of his father’s empire had come tumbling down about their ears…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luc’s mouth tightened as he thought of that time. Of the past four and a half years when he had concentrated single-mindedly, often ruthlessly, on rebuilding that business empire until it was bigger and better than ever. Years when there had been very few women in his life, and even then only ones who had shared his bed for the night and been quickly forgotten afterwards.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Had the young woman who now stood before him in the crisp black business suit, with her chestnut-brown hair secured in that no-nonsense bun at her nape, the ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("clear lines of her face bare of any make-up to enhance her natural beauty, been one of them?")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Somehow Luc thought not. Unlike "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(" woman, those women had invariably been tall and blonde, rich and vacuous socialites. Nevertheless, as he continued to look at her, that feeling of familiarity persisted…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His mouth quirked. ‘You appear to have forgotten your telephone call,’ he drawled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Annie gave a startled glance down at the mobile she still held in her hand. The mobile from which a concerned voice could be heard squawking, if not the actual words being spoken.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oliver.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In her utter shock at seeing Luc again, Annie had completely forgotten that she had been talking to Oliver when she had crashed into the tall Italian.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She swallowed hard. ‘If you will excuse me?’ She deliberately turned her back on the powerful effect of this man’s close proximity, intending to escape to somewhere more private to continue her call.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Although she wasn’t sure she was going to be able to talk to Oliver with any degree of normality after this chance, disturbing meeting. In fact, the sooner Annie was able to get away from Lake Garda—no, from Italy altogether—and the man she’d had a one-night stand with, who didn’t even "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("remember")]), _vm._v(" her, the better she was going to like it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Deeply aware that Italy was the place where she had met Luc and behaved so impulsively, Annie hadn’t wanted to attend this management course at the conference centre in a hotel on the shores of Lake Garda at all, and had only done so because her father had insisted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("A father who, still reeling from the death of Lillian, ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("his beloved third wife and Annie’s stepmother, had become dictatorial with all of his daughters following the scandal that had rocked the family to its very core during the celebration of the centenary Balfour Charity Ball the previous month.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Annie froze as she felt strong fingers curl about her upper arm before she had chance to walk away. Luc’s fingers. Long, elegant fingers that nevertheless possessed a compelling strength.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fingers that had once caressed and touched Annie more intimately than any other man ever had. And which still had the power to send an electrifying jolt of awareness down the length of her arm and up into the fullness of her breasts. Breasts that, to Annie’s embarrassment, instantly responded to the familiarity of that touch as they swelled inside her bra, the nipples pressing against the lacy material.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Annie’s eyes, the deep Balfour blue eyes, were flashing a warning as she turned back to face Luc. ‘Take your hand off me!’ She spoke between gritted teeth, her face having once again paled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luc lowered hooded lids at the vehemence he heard in her tone. No, he had not imagined it earlier; there was definitely some resentment being displayed here towards him, a resentment he wished to know more of.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He made no effort to release her. ‘Would you care to have dinner with me this evening?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her eyes widened as she stared up at him uncomprehendingly for several long seconds. ‘What?’ she finally snapped even as the colour rushed back into her cheeks.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("Luc gave a brief humourless smile. ‘I asked if you would have dinner with me this evening. In apology for ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("having almost knocked you over just now,’ he added, both of them fully aware that it was her lack of attention to where she was going that had caused the collision.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She gave him a speaking glance. ‘Thank you for the invitation,’ she answered drily. ‘But no.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luc narrowed dark eyes, unaccustomed to being turned down by any woman. ‘Why not?’ he asked bluntly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eyes the colour of cornflowers, and surrounded by thick dark lashes, glared at him fiercely. ‘Because I don’t allow myself to be picked up by men I don’t know in hotel hallways, that’s why! Now would you please let go of my arm or do I have to call a member of the management and have them throw you off the premises for harassing one of their guests?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That might prove interesting, considering that Luc’s family owned the hotel!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That will not be necessary,’ he murmured even as he slowly uncurled his fingers and released her arm. ‘The dinner invitation was no more than a gesture of apology on my part.’ He shrugged dismissively.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Annie, having already been completely thrown by Luc’s unexpected invitation to dinner, thankfully felt the easing of that tingling sensation in her arm and breasts once he had released her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Just as she also felt slight disappointment that she couldn’t—no, daren’t—accept his dinner invitation…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh, no—she couldn’t still be attracted to this man! Could she?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, of course not! He had erupted into her life, taken what he wanted from her and then literally disappeared into the sunset.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Annie had taken what she wanted from him?")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With three older sisters, all of whom had made headlines in the daily newspapers at one time or another, and three younger sisters—four now!—who looked to be heading the same way, Annie was the one who had always preferred to remain firmly in the shadows of the publicity so often connected with the Balfour name.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A fact her father had been well aware of when he encouraged her to join her university friends on that skiing holiday in Italy more than four years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To Annie’s surprise, away from the pressure and publicity that so often accompanied being a Balfour, and the constant competitiveness so typical of a Balfour family holiday, she had found herself relaxing and enjoying herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Consequently, when Luc had flashed that dangerousgrin at her and issued his challenge for her to accompany him down the steepest black run at the resort, Annie had been more than open to his heady brand of seduction.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So much so that she had behaved completely out of character after going back to Luc’s luxurious chalet with him. As he had suggested, they had drunk schnapps together while cooking a meal, Annie wrapped in a glorious rosy glow as the two of them made love in front of the blazing log fire.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It had been a time out of time. When she could just be Annie. And Luc could just be Luc.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But who was he really? Annie wondered now as she glanced at him cautiously. Because, from the expensive cut of his hair, the tailored suit, silk shirt and tie and handmade leather shoes, he was obviously someone important.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not to mention someone she had wanted to avoid seeing again at all costs!")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No apology is required,’ she assured him crisply. ‘Now, if you will excuse me, I really do have to finish my call.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luc regarded her with guarded intensity. ‘I cannot help feeling that the two of us "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("have")]), _vm._v(" met before,’ he insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘In another lifetime perhaps,’ she retorted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Perhaps,’ Luc echoed slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was something about the delicate curve of this woman’s jaw, the deep blue of her eyes, the husky, sexy softness of her voice, that he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("knew")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nor had Luc missed her response to merely the touch of his fingers on her arm. Her breasts had visibly swelled beneath the jacket of the black suit, the nipples pebble hard against the soft material of her blouse.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And he thought her eyes once again widened in alarm at his persistence in suggesting that they had met before.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Will you be remaining at the hotel for long?’ he asked curiously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The weekend only,’ she replied curtly. ‘But I’m here on business and expect to be kept very busy, so I doubt that we will have a chance to meet again,’ she added firmly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She so obviously "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hoped")]), _vm._v(" that they would not meet again, Luc acknowledged.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Having taken over as head of the family business empire four years ago following his father’s near-fatal heart attack, Luc was accustomed to being hotly pursued by women intent on becoming his wife or, failing that, his mistress. Whereas this woman could not have shown her lack of interest in him any more clearly.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which only increased Luc’s own interest in her. An interest he intended pursuing, with or without her cooperation…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gave a determined smile. ‘I would not be too sure of that, if I were you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once again she blinked, her creamy throat moving convulsively as she swallowed before speaking. ‘Just talking to you has already made me late for a meeting.’ She gave a pointed look at the slender gold watch on her wrist.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged broad shoulders. ‘Then a few minutes more will not make any difference, hmm?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The woman shook her head. ‘I’m sorry, but I dislike tardiness, in myself as well as others.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luc knew she was not in the least sorry. In fact, she couldn’t wait to get away!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The fiery snap in her stunning eyes, and the stubborn set of her chin, told Luc that she had no idea how her obvious determination to get away from him only increased his interest rather than diminished it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘In that case, I will say goodbye. For now,’ he added softly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘We will not meet again, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("signore")]), _vm._v(",’ she insisted, the delicate colour that entered her cheeks now due to temper rather than embarrassment at her previous rudeness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luc found himself giving her one of his rare smiles. ‘Fate has a way of deciding these things for us, I have found.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fate had already led Annie into behaving completely irrationally in this man’s company once, and she had no intention of putting that temptation in her way ever again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("Yet, if anything, this Luc was even more devastatingly ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("attractive than the man Annie had met before. There was a hard ruthlessness about him now, a haughty remoteness, that challenged as much as it beguiled.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As for his smile…!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Those moulded, sculptured lips had pulled back briefly over white and perfectly straight teeth, in a familiar wolfish smile that, although fleeting, had nevertheless made Annie’s heart pound harder and louder.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Despite everything, she realised with horror that she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" still attracted to him!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her mouth firmed. ‘I really do have to finish this call.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Luc’s mocking humour faded as he recalled that she had been talking to someone called Oliver when they had collided a few minutes ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A man named Oliver, who, from the lack of rings on her long and slender fingers, had not yet made a public claim on this woman, despite the fact that she’d huskily assured him that she loved him too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He nodded abruptly. ‘I too am late for an appointment.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The woman’s smile was saccharin sweet. ‘Then I really mustn’t delay you any longer, must I?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This woman needed to be put across someone’s knee, and her bottom firmly spanked, Luc decided ruefully. Her bare bottom. Her lush and curvaceous bare bottom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was an erotic image that flowered and grew in Luc’s mind and caused his thighs to throb and harden as he became fully aroused—something that hadn’t happened to him in years at just the thought of making love to a specific woman.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("Luc had spent years rebuilding his family’s wealth and business empire. Four long years when he had allowed ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("no other distractions, least of all an interest in a woman, to interfere with those plans.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Attractive as this woman was, Luc very much doubted that she would hold that interest for very long either. But her prickly nature indicated a passion that might prove fun while it lasted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Signorina.’")]), _vm._v(" He inclined his head in farewell, secure in the knowledge, in the pleasure, of her presence at Lake Garda for several more days at least.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Annie held her breath as she watched Luc’s long and arrogantly confident strides until he turned left at the end of the hallway, leaning weakly back against the wall of the hallway once he had disappeared from view. Dear God!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How had this happened? Why had it happened?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It had happened for the simple reason that her father, newly fired with a desire to guide the lives of his wayward daughters into less notorious and hopefully more worthwhile channels, had decided that Annie was to take a more active role in the Balfour business empire by attending this management course!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her protest that she had no interest in taking on a more high-profile role in her father’s management team hadn’t seemed to matter a jot to him. As the only one of Oscar’s eight daughters who actually worked for him, usually at the office complex at Balfour Manor, Oscar had just overridden all of Annie’s objections by threatening to sack her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Annie had known that he had meant that threat too. That Oscar was absolutely adamant in his decision that it was time—past time—that all of his daughters went out into the world to find themselves and what they really ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("wanted out of life. Even if the majority of them, Annie included, went kicking and screaming!")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which brought Annie back full circle to her presence here at this glamorous hotel set on the shore of beautiful Lake Garda in Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A hotel at which Luc, her ex-lover, was obviously also a guest…")])])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page25"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11f6e886","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426879234_ch01.vue
// module id = 75
// module chunks = 0